module.exports = new __parcel__URL__("Hiring Process.7a363ddb.svg").toString();